<script setup lang="ts">
import { ArgentoInsurancePaymentPeriodicities } from '~/config'

interface Props {
  amount?: number
  discountAmount?: number | null
  periodicity?: PropsTypesOf<typeof ArgentoInsurancePaymentPeriodicities>['value'] | null
  severity?: 'success' | 'danger' | null
  layout?: 'horizontal' | 'vertical'
}
const props = withDefaults(defineProps<Props>(), {
  amount: 0,
  discountAmount: null,
  paymentInfo: undefined,
  periodicity: null,
  argentoInsurancePaymentinstallments: null,
  severity: null,
  discount: undefined,
  layout: 'horizontal',
})

const dinamicClass = computed(() => ({
  'text-green-400': props.severity === 'success',
  'text-warn-400': props.severity === 'danger',
  'flex flex-wrap gap-1 leading-tight justify-center': props.layout === 'horizontal',
  'grid text-center': props.layout === 'vertical',
}))
</script>

<template>
  <div>
    <div
      class="text-center"
      :class="dinamicClass"
    >
      <span
        class="text-sm leading-none"
        :class="layout === 'horizontal' ? 'place-self-start pt-1' : ''"
      >
        RD$
      </span>
      <span
        class="font-bold leading-none"
        :class="layout === 'vertical' ? 'text-4xl' : 'text-5xl'"
      >
        {{
          formatCurrency({
            price: discountAmount ?? amount,
          })
        }}
      </span>
      <span
        v-if="periodicity"
        class="text-sm pb-1 leading-none"
        :class="layout === 'horizontal' ? 'place-self-end' : ''"
      >
        /
        {{ ArgentoInsurancePaymentPeriodicities[periodicity].text }}
      </span>
    </div>
    <div
      v-if="discountAmount"
      class="text-red-400 line-through text-center"
      :class="layout === 'vertical' ? 'md:text-lg' : 'text-lg md:text-xl'"
    >
      RD$
      {{
        formatCurrency({
          price: amount,
        })
      }}
    </div>
  </div>
</template>
